import * as React from 'react';
function useInputBoxed(_ref) {
  var {
    value,
    disabled,
    autoFocus,
    placeholder,
    onBlur,
    onFocus
  } = _ref;
  var inputRef = React.useRef();
  var [active, setActive] = React.useState(Boolean(value));
  var [focused, setFocused] = React.useState(Boolean(autoFocus && !disabled));
  React.useEffect(() => {
    if (!value && !autoFocus) {
      setActive(false);
    }
  }, [value, autoFocus]);
  React.useEffect(() => {
    var _inputRef$current;
    var inputValue = value !== null && value !== void 0 ? value : (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.value;
    if (inputValue && !active || placeholder) {
      setActive(true);
    }
  }, [value, placeholder, active, inputRef.current]);
  var setFocus = () => {
    var _inputRef$current2;
    setFocused(true);
    (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.focus();
  };
  var handleOnBlur = event => {
    setFocused(false);
    if (!event.target.value) {
      setActive(false);
    }
    if (onBlur) {
      onBlur(event);
    }
  };
  var handleOnFocus = event => {
    setFocused(true);
    setActive(true);
    if (onFocus) {
      onFocus(event);
    }
  };
  var handleOnClick = event => {
    if (disabled) {
      event.stopPropagation();
      return;
    }
    setFocus();
    setActive(true);
  };
  return {
    active,
    focused,
    inputRef,
    handleOnBlur,
    handleOnFocus,
    handleOnClick
  };
}
export { useInputBoxed };
//# sourceMappingURL=useInputBoxed.js.map